'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.Root = void 0;
var tslib_1 = require('tslib');
var react_1 = (0, tslib_1.__importStar)(require('react'));
var context_1 = require('../context');
var UUIDGenerator_1 = require('../services/UUIDGenerator');
function createDIContext() {
    return (0, context_1.getDIContext)();
}
var Root = function Root(_a) {
    var children = _a.children,
        operationService = _a.operationService,
        componentLifecycleService = _a.componentLifecycleService;
    var context = (0, react_1.useMemo)(createDIContext, []);
    context.registerService(new UUIDGenerator_1.UUIDGenerator());
    context.registerService(operationService);
    context.registerService(componentLifecycleService);
    return react_1.default.createElement(context_1.DIContext.Provider, { value: context }, children);
};
exports.Root = Root;
